export const commonFps = [23.976, 24, 25, 29.976, 30, 60];
export const DEFAULT_RENDER_FPS = 24;

export const renderSettingsOptions = {
  "1280 x 720": {
    width: 1280,
    height: 720,
    aspectRatio: 1.78,
    fps: commonFps,
  },

  // ========================

  "1920 x 1080": {
    width: 1920,
    height: 1080,
    aspectRatio: 1.78,
    fps: commonFps,
  },

  "1920 x 960": {
    width: 1920,
    height: 960,
    aspectRatio: 2,
    fps: commonFps,
  },

  "1920 x 1440": {
    width: 1920,
    height: 1440,
    aspectRatio: 1.33,
    fps: commonFps,
  },

  // ================================

  "1998 x 1080": {
    width: 1998,
    height: 1080,
    aspectRatio: 1.85,
    fps: commonFps,
  },

  "2048 x 858": {
    width: 2048,
    height: 858,
    aspectRatio: 2.39,
    fps: commonFps,
  },

  "2048 x 1080": {
    width: 2048,
    height: 1080,
    aspectRatio: 1.9,
    fps: commonFps,
  },

  "2048 x 1152": {
    width: 2048,
    height: 1152,
    aspectRatio: 1.78,
    fps: commonFps,
  },

  // ==================================

  "3840 x 2160": {
    width: 3840,
    height: 2160,
    aspectRatio: 1.78,
    fps: commonFps,
  },

  "3840 x 1608": {
    width: 3840,
    height: 1608,
    aspectRatio: 2.39,
    fps: commonFps,
  },

  "3840 x 2880": {
    width: 3840,
    height: 2880,
    aspectRatio: 1.33,
    fps: commonFps,
  },

  "3996 x 2160": {
    width: 3996,
    height: 2160,
    aspectRatio: 1.85,
    fps: commonFps,
  },

  // ======================================

  "4096 x 2160": {
    width: 4096,
    height: 2160,
    aspectRatio: 1.9,
    fps: commonFps,
  },

  "4096 x 1716": {
    width: 4096,
    height: 1716,
    aspectRatio: 2.39,
    fps: commonFps,
  },
};

export const fpsNumAndDen = {
  23.976: {
    num: 1001,
    den: 24000,
  },
  24: {
    num: 1,
    den: 24,
  },
  25: {
    num: 1,
    den: 25,
  },
  29.976: {
    num: 1001,
    den: 30000,
  },
  30: {
    num: 1,
    den: 30,
  },
  50: {
    num: 1,
    den: 50,
  },
  59.94: {
    num: 1001,
    den: 60000,
  },
  60: {
    num: 1,
    den: 60,
  },
  100: {
    num: 1,
    den: 100,
  },
  119.88: {
    num: 1001,
    den: 120000,
  },
  120: {
    num: 1,
    den: 120,
  },
};

export const FrameScreenSizeJSON = {
  1.38: {
    num: 0,
  },
  1.78: {
    num: 1,
  },
  1.85: {
    num: 2,
  },
  2.001: {
    num: 3,
  },
  2.38: {
    num: 4,
  },
};

export const getResolutionFromHeightAndWidth = (h, w) => {
  let res = null;
  Object.keys(renderSettingsOptions).forEach((resolution) => {
    const { width, height } = renderSettingsOptions[resolution];
    if (height == h && width == w) res = resolution;
  });
  return res;
};

export const getAspectRatio = (w, h) => {
  if (!w || !h) {
    return "16:9";
  }

  const gcd = (a, b) => {
    while (b !== 0) {
      [a, b] = [b, a % b];
    }
    return a;
  };

  const divisor = gcd(w, h);

  const width = w / divisor;
  const height = h / divisor;

  return `${width}:${height}`;
};

 // Import the spinner icon

export const getRenderStatus = (render) => {
  const { isVideoGenerated, isRederFinished, renderErrorMessage, updatedAt } = render;

  if (isVideoGenerated) {
    return "Completed";
  }

  if (isRederFinished && renderErrorMessage && renderErrorMessage.length > 0) {
    return "Failed";
  }

  if (isRederFinished === true) {
    return "Finished";
  }

  const oneDay = 1 * 24 * 60 * 60 * 1000;
  if (!isRederFinished && (+new Date() - +new Date(updatedAt)) > oneDay) {
    return "Failed";
  }

  return "Rendering...";
};


export const getRenderTime = (render) => {
  const { videoRenderTimeInMs } = render;

  if (videoRenderTimeInMs && videoRenderTimeInMs > 0) {
    return `${Math.round(videoRenderTimeInMs / (60 * 1000))} min(s)`;
  }

  return `Calculating`;
}

export const getfpsFromNumAndDen = (n, d) => {
  let res = null;
  Object.keys(fpsNumAndDen).forEach((fps) => {
    const { num, den } = fpsNumAndDen[fps];
    if (num == n && den == d) res = fps;
  });
  return res;
};
export const ALPHA_RENDER_FORMAT = "outputProRes4444 Alpha";

export const format = {
  H264: "outputH264",
  ProResProxy: "outputProResProxy",
  ProRes422Hq: "outputProRes422Hq",
  ProRes422Lt: "outputProRes422Lt",
  ProRes422Std: "outputProRes422Std",
  ProRes4444: "outputProRes4444",
  ProRes4444Alpha: ALPHA_RENDER_FORMAT,
  ProRes4444Xq: "outputProRes4444Xq",
};

export function isAlphaRenderFormat(value) {
  return String(value || "") === ALPHA_RENDER_FORMAT;
}

export function getFormatLabel(value) {
  const match = Object.entries(format).find(([, v]) => v === value);
  return match ? match[0] : String(value || "").replace(/^output/, "");
}
